import { useState, useEffect } from "react";
import { Heart } from "lucide-react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FavoriteButton = ({ listingId, className = "", size = "default" }) => {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [isFavorite, setIsFavorite] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && token) {
      checkFavoriteStatus();
    }
  }, [user, token, listingId]);

  const checkFavoriteStatus = async () => {
    try {
      const response = await axios.get(`${API}/favorites/check/${listingId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setIsFavorite(response.data.is_favorite);
    } catch (error) {
      console.error("Error checking favorite status:", error);
    }
  };

  const handleToggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!user || !token) {
      toast.info("Autentifică-te pentru a salva proprietăți favorite");
      navigate("/auth", { state: { from: window.location.pathname } });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${API}/favorites/${listingId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setIsFavorite(response.data.is_favorite);
      toast.success(response.data.message);
    } catch (error) {
      console.error("Error toggling favorite:", error);
      toast.error("Eroare la salvarea în favorite");
    } finally {
      setLoading(false);
    }
  };

  const sizeClasses = {
    small: "w-8 h-8",
    default: "w-10 h-10",
    large: "w-12 h-12"
  };

  const iconSizes = {
    small: "w-4 h-4",
    default: "w-5 h-5",
    large: "w-6 h-6"
  };

  return (
    <button
      data-testid={`favorite-btn-${listingId}`}
      onClick={handleToggle}
      disabled={loading}
      className={`
        ${sizeClasses[size]}
        rounded-full flex items-center justify-center
        transition-all duration-300 ease-out
        ${isFavorite 
          ? "bg-red-500 hover:bg-red-600 text-white shadow-lg shadow-red-200" 
          : "bg-white/90 hover:bg-white text-stone-400 hover:text-red-500 shadow-md"
        }
        ${loading ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:scale-110 active:scale-95"}
        ${className}
      `}
      title={isFavorite ? "Elimină din favorite" : "Adaugă la favorite"}
    >
      <Heart 
        className={`
          ${iconSizes[size]}
          transition-all duration-300
          ${isFavorite ? "fill-current scale-110" : ""}
          ${loading ? "animate-pulse" : ""}
        `}
        fill={isFavorite ? "currentColor" : "none"}
      />
    </button>
  );
};

export default FavoriteButton;
